import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ErrorPage from './ErrorPage';
import Home from './Home';
import EmptyPage from './EmptyPage';
import Donazioni from './Donazioni';
import ChiSiamo from './ChiSiamo';
import Progetti from './Progetti';
import Progetto1 from './Progetto1';
import Progetto2 from './Progetto2';
import Progetto3 from './Progetto3';
import Progetto4 from './Progetto4';
import Progetto5 from './Progetto5';
import Contatti from './Contatti';
import SitiAmici from './SitiAmici';
import Foto from './Foto';
import TrasparenzaPage from './TrasparenzaPage';
import Whatsapp from './Whatsapp';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';
import NoteLegali from './NoteLegali';


const router = createBrowserRouter([
  {
    path: "/",
    element: <EmptyPage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <App />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "chisiamo",
            element: <ChiSiamo />,
          },
          {
            path: "progetti",
            element: <Progetti />,
          },
          {
            path: "progetto-voce-volontari",
            element: <Progetto1 />,
          },
          {
            path: "progetto-donna",
            element: <Progetto2 />,
          },
          {
            path: "progetto-locali-storici",
            element: <Progetto3 />,
          },
          {
            path: "progetto-biblioteche",
            element: <Progetto4 />,
          },
          {
            path: "progetto-spasso-fvg",
            element: <Progetto5 />,
          },
          {
            path: "donazioni",
            element: <Donazioni />,
          },
          {
            path: "contatti",
            element: <Contatti />,
          },
          {
            path: "siti-amici",
            element: <SitiAmici />,
          },
          {
            path: "foto",
            element: <Foto />,
          },
          {
            path: "trasparenza",
            element: <TrasparenzaPage />,
          },
          {
            path: "whatsapp",
            element: <Whatsapp />,
          },
          {
            path: "privacy",
            element: <PrivacyPolicy />,
          },
          {
            path: "cookie-policy",
            element: <CookiePolicy />,
          },
          {
            path: "note-legali",
            element: <NoteLegali />,
          },
        ]
      },
    ],
  },],
);

console.log('react working');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);